<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>

      <FollawedRadioButtons
        all-match-route="/jorfs"
        follawed-route="/jorfs/follawed"
      />
    </div>

    <div class="params-row">
      <TotalMatched :item-count="store.item_count" />

      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Textes par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";

import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import FollawedRadioButtons from "@/follaw-fr/components/reusable/atoms/FollawedRouterRadioButtons.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useJorfsStore } from "@follaw-fr/stores/jorfs";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

// All filters in wanted display order with their labels
const filtersNames = {
  issuer: "Émetteur",
  nature: "Nature de texte",
};

const store = useJorfsStore();
const { selectedFilters } = storeToRefs(store);

const fetchJorfsList = async () => {
  selectedFilters.value.from = 0;
  await store.fetchJorfsList();
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      fetchJorfsList();
    },
  });

const showScrollTop = computed(() => selectedFilters.value.size > 20);

const resetAllFilters = () => {
  store.resetFilters();
  fetchJorfsList();
};

const addFilterItem = (event) => {
  const targetFilters = selectedFilters.value[event.filter] || [];

  const itemToAdd = event.item;

  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: [...targetFilters, itemToAdd],
  };
  fetchJorfsList();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] || [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }
  fetchJorfsList();
};

const activeFilters = computed(() => {
  let arr = [];
  // Put all selected options from all filters with said filter name in an array for the SelectedFilters component
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      const itemToAdd = filter;
      arr = [...arr, { filter: key, item: itemToAdd }];
    });
  });
  return arr;
});

const resetFilter = (event) => {
  delete selectedFilters.value[event];
  fetchJorfsList();
};
</script>
